// Scroll controls for the collection sublinks row.
// The track scrolls natively, so swipe and keyboard work before this upgrades; CSS shows the
// buttons on desktop only.

if (!customElements.get('collection-sublinks')) {
  customElements.define(
    'collection-sublinks',
    class CollectionSublinks extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.collection-sublinks__track');
        this.controls = this.querySelector('[data-sublinks-controls]');
        this.buttons = [...this.querySelectorAll('[data-sublinks-step]')];

        if (!this.track || !this.controls || !this.buttons.length) return;

        this.controller = new AbortController();
        const { signal } = this.controller;

        for (const button of this.buttons) {
          button.addEventListener('click', this.step.bind(this), { signal });
        }

        this.track.addEventListener('scroll', this.sync.bind(this), { signal, passive: true });
        window.addEventListener('resize', this.sync.bind(this), { signal });

        // A row measured while hidden reports 0/0, which reads as both ends at once and hides
        // every arrow with nothing left to correct it. This fires on the transition away from zero.
        this.resizeObserver = new ResizeObserver(() => this.sync());
        this.resizeObserver.observe(this.track);

        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }

      step(event) {
        const button = event.currentTarget;
        // aria-disabled leaves the button clickable, so the guard cannot live in the styling.
        if (button.getAttribute('aria-disabled') === 'true') return;

        // Not FoxTheme.config: if that global is late, undefined reads as "no preference".
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.track.scrollBy({
          left: Number(button.dataset.sublinksStep) * this.track.clientWidth * 0.8,
          behavior: reduced ? 'auto' : 'smooth',
        });
      }

      sync() {
        // Sub-pixel track widths make an exact comparison unreliable at some zoom levels.
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        const scrollable = overflow > 1;

        this.controls.toggleAttribute('hidden', !scrollable);
        if (!scrollable) return;

        const atStart = this.track.scrollLeft <= 1;
        const atEnd = this.track.scrollLeft >= overflow - 1;

        for (const button of this.buttons) {
          const blocked = Number(button.dataset.sublinksStep) < 0 ? atStart : atEnd;
          button.setAttribute('aria-disabled', String(blocked));
        }
      }
    }
  );
}
